import { SliceComponentProps } from "@prismicio/react";
import { Slice } from "@prismicio/types";
import React from "react";
import { XometryEverywhereSliceFragment } from "../../types/graphql";
import { IPageContext } from "../../types/types";
import { baseDomain } from "../../utils/constants";
import { SharedSliceType } from "../shared-slice/shared-slice";
import {
  XomEverywhereIframe,
  XomEverywhereContainer,
} from "./xom-everywhere.styled";

export type IXomEverywhereProps = Slice<
  SharedSliceType,
  XometryEverywhereSliceFragment
> & { type: SharedSliceType };

const XomEverywhere = ({
  slice,
  context,
}: SliceComponentProps<IXomEverywhereProps, IPageContext>) => {
  return (
    (baseDomain && (
      <XomEverywhereContainer>
        <XomEverywhereIframe
          src={`https://www.${
            baseDomain === "xometry.com" ? "xometry.com" : "stage.xometry.net"
          }/quoting/loader/?workflow=browser`}
        />
      </XomEverywhereContainer>
    )) || <></>
  );
};

export default XomEverywhere;
